import { useEffect, useState } from "react";
import { useAuthStore } from "../stores/authStore";

/**
 * Evita evaluar rutas protegidas antes de rehidratar el token desde sessionStorage.
 */
export default function AuthHydrationGate({ children }) {
  const [ready, setReady] = useState(() => useAuthStore.persist?.hasHydrated?.() ?? true);

  useEffect(() => {
    const persistApi = useAuthStore.persist;
    if (!persistApi?.onFinishHydration) {
      setReady(true);
      return undefined;
    }
    if (persistApi.hasHydrated?.()) {
      setReady(true);
    }
    const unsub = persistApi.onFinishHydration(() => {
      setReady(true);
    });
    return unsub;
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-[100dvh] items-center justify-center bg-[#050505] text-xs uppercase tracking-[0.2em] text-[rgba(255,255,255,0.45)]">
        Cargando…
      </div>
    );
  }

  return children;
}
